import Scene from "./scene";

export default function App() {
  return (
    <main className="h-screen w-screen">
      <Scene />
    </main>
  );
}
